import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useState } from 'react';
import { upsertPerson } from 'services/api';
import { ProgressHeader } from 'shared/components/Form/MultiStepForm/ProgressHeader';
import { StepOne } from 'shared/components/Form/MultiStepForm/StepOne';
import { IStepOneData } from 'shared/components/Form/MultiStepForm/StepOne/types';
import { StepSucess } from 'shared/components/Form/MultiStepForm/StepSucess';
import { StepTwo } from 'shared/components/Form/MultiStepForm/StepTwo';
import { IStepTwoData } from 'shared/components/Form/MultiStepForm/StepTwo/types';
import { Container } from 'shared/components/Form/MultiStepForm/style';

export const MultiStepForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [stepOneValues, setStepOneValues] = useState<IStepOneData>({} as IStepOneData);
  const [stepTwoValues, setStepTwoValues] = useState<IStepTwoData>({} as IStepTwoData);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (stepTwoData?: typeof stepTwoValues) => {
    const data = stepTwoData ?? stepTwoValues;

    const payload = {
      cpf: data.cpf,
      fullName: data.name,
      email: stepOneValues.email,
      phoneNumber: stepOneValues.phoneNumber,
      monthlyIncome: (data.monthlyIncome / 100),
      isLead: true,
      phoneAreaCode: stepOneValues.phoneAreaCode,
    };

    try {
      setLoading(true);
      await upsertPerson(payload);
      setCurrentStep(3);
    } catch (error: any) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <ProgressHeader currentStep={currentStep} />
      {currentStep === 1 && (
        <StepOne
          onNextStep={(data) => {
            setStepOneValues(data);
            setCurrentStep(2);
          }}
          defaultValues={stepOneValues}
        />
      )}
      {currentStep === 2 && (
        <StepTwo
          goBack={(step, data) => {
            setCurrentStep(step);
            setStepTwoValues(data)
          }}
          onGoToStep={(data) => {
            setStepTwoValues(data);
            handleSubmit(data);
          }}
          loading={loading}
          defaultValues={stepTwoValues}
        />
      )}

      {loading && (
        <Box position={'absolute'} top={'40%'} left={'45%'}>
          <CircularProgress size={72} />
        </Box>
      )}

      {!loading && currentStep === 3 && <StepSucess />}
    </Container>
  );
};
